import { cn } from '@/lib/utils';

const mockDataTable1 = [
  {
    id: 1,
    title: 'Status',
    data: 'Healthy',
  },
  {
    id: 2,
    title: 'Subscription',
    data: 'Business',
  },
  {
    id: 3,
    title: 'Tellets last 30 days',
    data: '16',
  },
  {
    id: 4,
    title: 'Change in tellets last 30 days',
    data: '+80%',
  },
  {
    id: 5,
    title: 'End date plan',
    data: '15/04/2025',
  },
  {
    id: 6,
    title: 'Automatic renewal',
    data: 'On',
  },
  {
    id: 7,
    title: 'Last activity',
    data: '28/01/2024',
  },
];

const mockDataTable2 = [
  {
    id: 1,
    title: 'Revenue this year',
    data: '$49.320',
  },
  {
    id: 2,
    title: 'Change in yearly revenue',
    data: '+11%',
  },
  {
    id: 3,
    title: 'Total revenue',
    data: '$89.432',
  },
  {
    id: 4,
    title: 'Account Manager',
    data: 'Stefan T.',
  },
];

function OrganizationSummary() {
  return (
    <div className="flex flex-col w-full gap-4">
      <h1 className="font-bold">Summary</h1>
      <div className="flex flex-wrap w-full gap-8">
        {/* table 1 */}
        <div className="flex flex-col w-fit">
          {mockDataTable1?.map((item) => (
            <div key={item.id} className="flex items-center text-sm font-medium border">
              <div className="py-1 pl-3 w-60">{item.title}</div>
              <div className="flex items-center justify-center py-1.5 border-l-2 w-44">
                <p
                  className={cn(
                    item?.title === 'Status' &&
                      'px-5 text-green-800 w-fit py-px bg-green-200 rounded-full',
                    item?.title === 'Subscription' &&
                      'px-5 text-purple-800 w-fit py-px bg-purple-200 rounded-full',
                  )}
                >
                  {item.data}
                </p>
              </div>
            </div>
          ))}
        </div>
        {/* table 2 */}
        <div className="flex flex-col w-fit">
          {mockDataTable2?.map((item) => (
            <div key={item.id} className="flex items-center text-sm font-medium border">
              <div className="py-1 pl-3 w-60">{item.title}</div>
              <div className="flex items-center justify-center py-1.5 border-l-2 w-44">
                <p
                  className={cn(
                    item?.title === 'Change in yearly revenue' &&
                      'px-5 text-green-800 w-fit py-px bg-green-200 rounded-full',
                  )}
                >
                  {item.data}
                </p>
              </div>
            </div>
          ))}
        </div>
        {/* action links/buttons */}
        <ul className="flex flex-col gap-2 ml-4 whitespace-nowrap">
          <li>
            <button
              type="button"
              className="font-semibold underline transition-all ease-in-out hover:text-primary"
            >
              Download action log
            </button>
          </li>
          <li>
            <button
              type="button"
              className="font-semibold underline transition-all ease-in-out hover:text-primary"
            >
              Login as Admin
            </button>
          </li>
          <li>
            <button
              type="button"
              className="font-semibold underline transition-all ease-in-out hover:text-primary"
            >
              Suspend organization
            </button>
          </li>
          <li>
            <button
              type="button"
              className="font-semibold underline transition-all ease-in-out hover:text-primary"
            >
              Download payment history
            </button>
          </li>
          <li>
            <button
              type="button"
              className="font-semibold underline transition-all ease-in-out hover:text-primary"
            >
              Manage Subscription
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default OrganizationSummary;
